export default __webpack_public_path__ + "static/media/o6.b5a2b8b4.jpg";